import $ from 'jquery';
import slick from 'slick-carousel';
import projectSettings from './project-settings';



/* Sliders
********************************************/

$(function() {

	if ($('.js-posts-slider-mobile').length) {
		const settings = {
			mobileFirst: true,
			infinite: false,
			autoplay: false,
			adaptiveHeight: false,
			draggable: true,
			swipe: true,
			fade: false,
			variableWidth: true,
			slidesToShow: 1,
			slidesToScroll: 1,
			dots: false,
			dotsClass: 'c-slider__dots',
			arrows: false,
			nextArrow: '<a href="" class="c-slider__arrow c-slider__arrow--next"></a>',
			prevArrow: '<a href="" class="c-slider__arrow c-slider__arrow--prev"></a>',
			responsive: [
				{
					breakpoint: projectSettings.breakpointMD - 1,
					settings: 'unslick'
				}
			]
		};

		$('.js-posts-slider-mobile').slick( settings );

		$( window ).on( 'resize orientationchange', function() {
			$('.js-posts-slider-mobile').each( function() {
				var $el = $( this );

				if ( $( window ).width() < projectSettings.breakpointMD && ! $el.hasClass( 'slick-initialized' ) ) {
					$el.slick( settings );
				}
			} );
		} );
	}


	if ($('.js-products-slider').length) {
		const settings = {
			mobileFirst: true,
			infinite: false,
			autoplay: false,
			adaptiveHeight: false,
			draggable: true,
			swipe: true,
			fade: false,
			variableWidth: false,
			slidesToShow: 1,
			slidesToScroll: 1,
			dots: true,
			dotsClass: 'c-slider__dots',
			arrows: true,
			nextArrow: '<a href="" class="c-slider__arrow c-slider__arrow--base c-slider__arrow--next"><svg class="c-slider__arrow-thick o-icon o-svg-icon"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="' + window.designstudio.themeAssetsUrl + '/sprite/icons.svg#icon-chevron"></use></svg></a>',
			prevArrow: '<a href="" class="c-slider__arrow c-slider__arrow--base c-slider__arrow--prev"><svg class="c-slider__arrow-thick o-icon o-svg-icon"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="' + window.designstudio.themeAssetsUrl + '/sprite/icons.svg#icon-chevron"></use></svg></a>',
			responsive: [
				{
					breakpoint: projectSettings.breakpointSM - 1,
					settings: {
						slidesToShow: 2,
						slidesToScroll: 2,
					}
				},
				{
					breakpoint: projectSettings.breakpointMD - 1,
					settings: {
						slidesToShow: 3,
						slidesToScroll: 3,
					}
				}
			]
		};

		$('.js-products-slider').slick( settings );
	}


	if ($('.js-document-slider').length) {
		const settings = {
			mobileFirst: true,
			infinite: false,
			autoplay: false,
			adaptiveHeight: false,
			draggable: true,
			swipe: true,
			fade: false,
			variableWidth: true,
			slidesToShow: 1,
			slidesToScroll: 1,
			dots: false,
			dotsClass: 'c-slider__dots',
			arrows: true,
			nextArrow: '<a href="" class="c-slider__arrow c-slider__arrow--base c-slider__arrow--next"><svg class="c-slider__arrow-thick o-icon o-svg-icon"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="' + window.designstudio.themeAssetsUrl + '/sprite/icons.svg#icon-chevron"></use></svg></a>',
			prevArrow: '<a href="" class="c-slider__arrow c-slider__arrow--base c-slider__arrow--prev"><svg class="c-slider__arrow-thick o-icon o-svg-icon"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="' + window.designstudio.themeAssetsUrl + '/sprite/icons.svg#icon-chevron"></use></svg></a>',
			responsive: [
				{
					breakpoint: projectSettings.breakpointSM - 1,
					settings: {
						variableWidth: false,
						slidesToShow: 2,
						slidesToScroll: 2,
					}
				},
				{
					breakpoint: projectSettings.breakpointMD - 1,
					settings: {
						variableWidth: false,
						slidesToShow: 3,
						slidesToScroll: 3,
					}
				},
				{
					breakpoint: projectSettings.breakpointXL - 1,
					settings: {
						variableWidth: false,
						slidesToShow: 3,
						slidesToScroll: 3,
						dots: true,
					}
				}
			]
		};

		$('.js-document-slider').slick( settings );
	}


	/**
	 * Moved .js-gallery-slider and .js-gallery-nav-slider to product-single.js, this shouldn't break anything but
	 * leaving this here for reference if it does.
	 */

	// if ($('.js-gallery-slider').length) {
	// 	$('.js-gallery-slider').slick({
	// 		mobileFirst: false,
	// 		infinite: false,
	// 		autoplay: false,
	// 		adaptiveHeight: true,
	// 		draggable: true,
	// 		swipe: true,
	// 		fade: true,
	// 		variableWidth: false,
	// 		slidesToShow: 1,
	// 		slidesToScroll: 1,
	// 		dots: false,
	// 		dotsClass: 'c-slider__dots',
	// 		arrows: false,
	// 		nextArrow: '<a href="" class="c-slider__arrow c-slider__arrow--next"><svg class="c-slider__arrow-thick o-icon o-svg-icon"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="' + window.designstudio.themeAssetsUrl + '/sprite/icons.svg#icon-chevron"></use></svg></a>',
	// 		prevArrow: '<a href="" class="c-slider__arrow c-slider__arrow--prev"><svg class="c-slider__arrow-thick o-icon o-svg-icon"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="' + window.designstudio.themeAssetsUrl + '/sprite/icons.svg#icon-chevron"></use></svg></a>',
	// 		//appendArrows: '.slick-list',
	// 		asNavFor: '.js-gallery-nav-slider',
	// 		responsive: [
	// 			{
	// 				breakpoint: projectSettings.breakpointLG,
	// 				settings: {
	// 					fade: false,
	// 				}
	// 			}
	// 		]
	// 	});
	// 	$('.js-gallery-nav-slider').slick({
	// 		mobileFirst: false,
	// 		infinite: false,
	// 		autoplay: false,
	// 		adaptiveHeight: true,
	// 		draggable: true,
	// 		swipe: true,
	// 		fade: false,
	// 		variableWidth: true,
	// 		slidesToShow: 6,
	// 		slidesToScroll:6,
	// 		swipeToSlide: true,
	// 		//centerMode: true,
	// 		//centerPadding: '50px',
	// 		focusOnSelect: true,
	// 		dots: false,
	// 		dotsClass: 'c-slider__dots',
	// 		arrows: true,
	// 		nextArrow: '<a href="" class="c-slider__arrow c-slider__arrow--base c-slider__arrow--next"><svg class="c-slider__arrow-thick o-icon o-svg-icon"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="' + window.designstudio.themeAssetsUrl + '/sprite/icons.svg#icon-chevron"></use></svg></a>',
	// 		prevArrow: '<a href="" class="c-slider__arrow c-slider__arrow--base c-slider__arrow--prev"><svg class="c-slider__arrow-thick o-icon o-svg-icon"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="' + window.designstudio.themeAssetsUrl + '/sprite/icons.svg#icon-chevron"></use></svg></a>',
	// 		asNavFor: '.js-gallery-slider',
	// 		responsive: [
	// 			{
	// 				breakpoint: projectSettings.breakpointXL,
	// 				settings: {
	// 					slidesToShow: 4,
	// 					slidesToScroll: 4,
	// 				}
	// 			},
	// 			{
	// 				breakpoint: projectSettings.breakpointLG,
	// 				settings: {
	// 					slidesToShow: 6,
	// 					slidesToScroll: 6,
	// 				}
	// 			},
	// 			{
	// 				breakpoint: projectSettings.breakpointMD,
	// 				settings: {
	// 					slidesToShow: 5,
	// 					slidesToScroll: 5,
	// 				}
	// 			},
	// 			{
	// 				breakpoint: projectSettings.breakpointSM,
	// 				settings: {
	// 					slidesToShow: 3,
	// 					slidesToScroll: 3,
	// 				}
	// 			}
	// 		]
	// 	});
	// }


	if ($('.js-gallery-slider-2').length) {
		$('.js-gallery-slider-2').slick({
			mobileFirst: false,
			infinite: true,
			autoplay: false,
			adaptiveHeight: true,
			draggable: true,
			swipe: true,
			fade: false,
			variableWidth: false,
			slidesToShow: 1,
			slidesToScroll: 1,
			swipeToSlide: true,
			//centerMode: true,
			//centerPadding: '50px',
			focusOnSelect: true,
			dots: false,
			dotsClass: 'c-slider__dots',
			arrows: true,
			nextArrow: '<a href="" class="c-slider__arrow c-slider__arrow--base c-slider__arrow--next"><svg class="c-slider__arrow-thick o-icon o-svg-icon"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="' + window.designstudio.themeAssetsUrl + '/sprite/icons.svg#icon-chevron"></use></svg></a>',
			prevArrow: '<a href="" class="c-slider__arrow c-slider__arrow--base c-slider__arrow--prev"><svg class="c-slider__arrow-thick o-icon o-svg-icon"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="' + window.designstudio.themeAssetsUrl + '/sprite/icons.svg#icon-chevron"></use></svg></a>',
			asNavFor: '.js-gallery-nav-slider-2',
		});
		$('.js-gallery-nav-slider-2').slick({
			mobileFirst: false,
			infinite: true,
			autoplay: false,
			adaptiveHeight: true,
			draggable: false,
			swipe: false,
			fade: true,
			variableWidth: false,
			slidesToShow: 1,
			slidesToScroll: 1,
			dots: true,
			dotsClass: 'c-slider__dots',
			arrows: false,
			nextArrow: '<a href="" class="c-slider__arrow c-slider__arrow--next"><svg class="c-slider__arrow-thick o-icon o-svg-icon"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="' + window.designstudio.themeAssetsUrl + '/sprite/icons.svg#icon-chevron"></use></svg></a>',
			prevArrow: '<a href="" class="c-slider__arrow c-slider__arrow--prev"><svg class="c-slider__arrow-thick o-icon o-svg-icon"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="' + window.designstudio.themeAssetsUrl + '/sprite/icons.svg#icon-chevron"></use></svg></a>',
			//appendArrows: '.slick-list',
			asNavFor: '.js-gallery-slider-2',
		});
	}

	if ($('.js-gallery-slider-3').length) {
		$('.js-gallery-slider-3').slick({
			mobileFirst: false,
			infinite: false,
			autoplay: false,
			adaptiveHeight: true,
			draggable: true,
			swipe: true,
			fade: false,
			variableWidth: false,
			slidesToShow: 1,
			slidesToScroll: 1,
			dots: true,
			dotsClass: 'c-slider__dots',
			arrows: true,
			nextArrow: '<a href="" class="c-slider__arrow c-slider__arrow--base c-slider__arrow--next"><svg class="c-slider__arrow-thick o-icon o-svg-icon"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="' + window.designstudio.themeAssetsUrl + '/sprite/icons.svg#icon-chevron"></use></svg></a>',
			prevArrow: '<a href="" class="c-slider__arrow c-slider__arrow--base c-slider__arrow--prev"><svg class="c-slider__arrow-thick o-icon o-svg-icon"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="' + window.designstudio.themeAssetsUrl + '/sprite/icons.svg#icon-chevron"></use></svg></a>',
			//appendArrows: '.slick-list',
		});
	}



} );
